<template>
  <div class="host vm-form-control">
    <div class="vm-form-control-label">
      {{ control.label }}
    </div>
    <div class="vm-form-control-input">
      <b-form-input
        v-if="control.type === 'text'"
        type="text"
        v-model="data.value"
        :placeholder="control.placeholder"
      ></b-form-input>
      <b-form-textarea
        v-if="control.type === 'textarea'"
        v-model="data.value"
        :placeholder="control.placeholder"
        :rows="control.rows"
      ></b-form-textarea>
      <multiselect
        v-if="control.type === 'select'"
        v-model="data.value"
        track-by="value"
        label="label"
        :options="options[control.optionName]"
        :searchable="false"
        :show-labels="false"
        :placeholder="control.placeholder"
      ></multiselect>
      <multiselect
        v-if="control.type === 'autocomplete'"
        v-model="data.value"
        label="label"
        track-by="value"
        open-direction="bottom"
        :show-labels="false"
        :placeholder="control.placeholder"
        :options="autocompleteOptions"
        :searchable="true"
        :loading="isLoading"
        :internal-search="false"
        :clear-on-select="false"
        :close-on-select="true"
        :options-limit="20"
        :max-height="600"
        :show-no-results="true"
        :hide-selected="false"
        :preserve-search="true"
        tag-placeholder="Добавить..."
        :taggable="true"
        @tag="addTag"
        @select="$emit('select', $event)"
        @open="open"
        @search-change="asyncFind"
      >
        <span slot="noResult">
          По вашему запросу ничего не найдено
        </span>
      </multiselect>
      <b-form-input
        v-if="control.type === 'date'"
        type="date"
        v-model="data.value"
        :placeholder="control.placeholder"
      ></b-form-input>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { debounce } from 'lodash';

export default {
  components: {
    Multiselect
  },
  props: {
    control: Object,
    options: Object,
    data: Object
  },
  data: () => ({
    isLoading: false,
    autocompleteOptions: [],
    newVal: ''
  }),
  methods: {
    addTag(evt) {
      this.newVal = {label: evt, value: evt};
      this.data.value = this.newVal;
    },
    async open() {
      this.isLoading = true;
      if (!this.autocompleteOptions.length) {
        await this.loadOptions(this.data.value);
      }
      this.isLoading = false;
    },
    asyncFind: debounce(async function(search) {
      this.isLoading = true;
      await this.loadOptions(search);
      this.isLoading = false;
    }, 400),
    async loadOptions(search) {
      const { getLabel, getValues } = this.options[this.control.optionName];
      const { items } = await getValues(search);
      this.autocompleteOptions = items.map(item => getLabel(item));
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.host ::v-deep .multiselect__placeholder {
  line-height: 18px;
}
.vm-form-control {
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 1rem;
}
.vm-form-control-label {
  width: 30%;
  color: #646464;
}
.vm-form-control-input {
  width: 70%;
}
@media (max-width: 700px) {
  .vm-form-control {
    flex-direction: column;
  }
  .vm-form-control-label {
    margin-bottom: 0.3rem;
  }
  .vm-form-control-label,
  .vm-form-control-input {
    width: 100%;
  }
}
</style>
